import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { LifeBuoy, Sparkles, MessageSquare, Accessibility, BookOpen, X } from "lucide-react";
import { useSecurity } from "../context/SecurityContext";
import { tr } from "../lib/i18n";

const open = (what) => window.dispatchEvent(new CustomEvent("hv:open", { detail: what }));
const AGENTS = ["health_agent", "finance_agent"];

// One floating help button replaces the separate AI, Feedback and Accessibility buttons.
export const HelpLauncher = ({ vaultPaths }) => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const { pathname } = useLocation();
  const sec = useSecurity();
  const { unlocked, member } = sec || {};
  const agent = AGENTS.includes(member?.role);
  const items = [
    unlocked && !agent && pathname !== "/vault" && pathname !== "/bereavement" && { id: "chat", label: "Ask AI about your vault", Icon: Sparkles },
    unlocked && !agent && { id: "feedback", label: "Send feedback", Icon: MessageSquare },
    { id: "a11y", label: "Accessibility", Icon: Accessibility },
    { id: "help", label: "Help center", Icon: BookOpen },
  ].filter(Boolean);
  useEffect(() => {
    if (!show) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setShow(false); };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [show]);
  const outerOnVault = !sec && vaultPaths?.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  const pick = (id) => { setShow(false); if (id === "help") window.location.assign("/help"); else open(id); };
  if (outerOnVault || pathname.startsWith("/sign/") || pathname.startsWith("/template/") || pathname.startsWith("/guest-code/") || pathname.startsWith("/gift/")) return null;
  return (
    <div ref={ref} className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[60] print:hidden" data-testid="help-launcher">
      {show && (
        <ul className="absolute bottom-14 right-0 w-60 rounded-2xl border border-border bg-card shadow-xl p-1.5" role="menu" data-testid="help-launcher-menu">
          {items.map(({ id, label, Icon }) => (
            <li key={id}><button type="button" role="menuitem" onClick={() => pick(id)} className="w-full flex items-center gap-3 rounded-xl px-3 h-11 text-sm hover:bg-muted text-left" data-testid={`help-launcher-${id}`}><Icon className="h-4 w-4 text-primary" /> {tr(label)}</button></li>
          ))}
        </ul>
      )}
      <button type="button" onClick={() => setShow((v) => !v)} aria-label={tr("Help")} aria-expanded={show} className="h-12 w-12 rounded-full bg-primary text-primary-foreground shadow-lg shadow-black/20 grid place-items-center hover:scale-105 transition-transform" data-testid="help-launcher-btn">
        {show ? <X className="h-5 w-5" /> : <LifeBuoy className="h-5 w-5" />}
      </button>
    </div>
  );
};
